import { Component, EventEmitter, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'shared-deny',
    templateUrl: './deny.component.html'
})
export class DenyComponent {

    denyMessage: string;

    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<DenyComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.denyMessage = data;
    }
    
}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/common/deny.component.ts